<ng-container *ngIf="ui.viewportSize$ | async as viewportSize">
    <div
        id="body-container"
        [class.sb-layout-and-footer-container]="!(printLayout$ | async)"
        #layoutContainer
    >
        <div>
            <ng-container *ngIf="disconnected">
                <app-connection-sb-overlay></app-connection-sb-overlay>
            </ng-container>
        </div>
        <app-sb-menu *ngIf="loggedIn$ | async"></app-sb-menu>
        <main>
            <ng-container *ngIf="{ animation: animation$ | async } as modal">
                <div
                    class="modal-container-div"
                    [@routeTransition]="modal.animation"
                    [ngStyle]="{ 'pointer-events': isModalActive ? null : 'none' }"
                >
                    <router-outlet
                        name="modal"
                        (activate)="activateModal()"
                        (deactivate)="activateModal(false)"
                    ></router-outlet>
                </div>
                <div
                    class="dialog-container-div"
                    [ngStyle]="{ 'pointer-events': isDialogActive ? null : 'none' }"
                >
                    <router-outlet
                        name="dialog"
                        (activate)="activateDialog()"
                        (deactivate)="activateDialog(false)"
                    ></router-outlet>
                </div>
            </ng-container>
            <router-outlet></router-outlet>
        </main>
        <footer>
            <app-sb-footer *ngIf="loggedIn$ | async"></app-sb-footer>
        </footer>
    </div>
</ng-container>
<ng-container *ngIf="session.isAuthenticated$ | async">
    <sb-disclaimer name="market-data"></sb-disclaimer>
</ng-container>
